export default {
    Auth: {
        mandatorySignIn: 'true',
        region: process.env.REACT_APP_REGION,
        userPoolId: process.env.REACT_APP_USERPOOL_ID,
        identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_USERPOOL_WEBCLIENT_ID,
    }
  };
  